import { useQuery } from 'hooks/useCustomQuery';
import getAllLocations from 'API/Location/getAllLocations';

const useGetLocationOptions = () => {
    return useQuery({
        queryKey: ['LocationOptions'],
        queryFn: getAllLocations,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

export default useGetLocationOptions;
